import { api_GET, api_POST, api_PUT } from './_api';
import { getSessionCookie } from 'helpers/cookies';
const correioInterno_api = {
    GetList: () => {
        const usuario = getSessionCookie();
        const promise = new Promise((resolve, reject) => {
            api_GET(`CorreioInterno/${usuario.acesso.modulo != "Gestor" ? "Destino" : "Gestor"}/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`CorreioInterno/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetDestinatarios: (filtro) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`CorreioInterno/GetDestinatarios`, filtro)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`CorreioInterno/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    AtualizaLeitura: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`CorreioInterno/AtualizarLeitura/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },

}

export default correioInterno_api;